import {
  getHistoryState,
  JoinCard,
  LoginCard,
  PasswordResetCard,
} from "@indietabletop/appkit";
import { m } from "../messages.ts";
import { Page } from "./Page/Page.tsx";

export function LoginPage() {
  return (
    <Page title="Account" backHref="~/">
      <LoginCard
        description={m.loginDescription}
        defaultValues={{ email: getHistoryState()?.emailValue }}
      />
    </Page>
  );
}

export function PasswordResetPage() {
  return (
    <Page title="Account" backHref="~/">
      <PasswordResetCard
        defaultValues={{ email: getHistoryState()?.emailValue }}
      />
    </Page>
  );
}

export function JoinPage() {
  return (
    <Page title="Account" backHref="~/">
      <JoinCard defaultValues={{ email: getHistoryState()?.emailValue }} />
    </Page>
  );
}
